import React from 'react';

import { InfoHeaderRowProps } from '../types';
import styles from './styles.module.css';

export function InfoHeaderRow({
  label,
  as: Component = 'div',
  ariaLevel = 4,
}: InfoHeaderRowProps) {
  if (Component === 'div') {
    return (
      <div role="heading" aria-level={ariaLevel} className={styles.headerRow}>
        {label}
      </div>
    );
  }

  return <Component className={styles.headerRow}>{label}</Component>;
}
